import { CheckoutField, FeatureFlag, TextKey } from '@mews-distributor/common';
import { useFeatureFlag } from '@mews/framework/feature-flags';
import { LocalizedText } from '@mews/framework/localization';
import { Stack } from '@optimus-web/core';

import { CheckoutInput } from '../CheckoutInput';
import { CheckoutPhoneInput } from '../CheckoutPhoneInput';
import { EmailInput } from '../EmailInput';

export const BookerForm = () => {
    const isPhoneInputPrototypeEnabled = useFeatureFlag(FeatureFlag.enablePhoneInputPrototype);
    const fallBackPhoneInput = (
        <CheckoutInput
            // @ts-expect-error $TSFixMeError: Type '{ name: CheckoutField; label: Element; autoComplete: string; type: string; }' is not assignable to type 'Intrinsic...
            name={CheckoutField.BookerTelephone}
            label={<LocalizedText textKey={TextKey.PhoneNumber} />}
            autoComplete="tel"
            type="tel"
        />
    );
    return (
        <Stack spacing="200" vertical>
            <Stack
                spacing="200"
                distribution="stretch"
                largePhoneMax={{
                    vertical: true,
                }}
            >
                <CheckoutInput
                    // @ts-expect-error $TSFixMeError: Type '{ name: CheckoutField; autoComplete: string; label: Element; }' is not assignable to type 'IntrinsicAttributes & O...
                    name={CheckoutField.BookerFirstName}
                    autoComplete="given-name"
                    label={<LocalizedText textKey={TextKey.FirstName} />}
                />
                <CheckoutInput
                    // @ts-expect-error $TSFixMeError: Type '{ name: CheckoutField; autoComplete: string; label: Element; }' is not assignable to type 'IntrinsicAttributes & O...
                    name={CheckoutField.BookerLastName}
                    autoComplete="family-name"
                    label={<LocalizedText textKey={TextKey.LastName} />}
                />
            </Stack>
            <Stack
                spacing="200"
                distribution="stretch"
                largePhoneMax={{
                    vertical: true,
                }}
            >
                <EmailInput
                    name={CheckoutField.BookerEmail}
                    helper={<LocalizedText textKey={TextKey.WeWillSendConfirmationToThisEmail} />}
                />

                {isPhoneInputPrototypeEnabled ? (
                    <CheckoutPhoneInput
                        name={CheckoutField.BookerTelephone}
                        label={<LocalizedText textKey={TextKey.PhoneNumber} />}
                        fallback={fallBackPhoneInput}
                    />
                ) : (
                    fallBackPhoneInput
                )}
            </Stack>
        </Stack>
    );
};
